import * as z from "zod/v4";

export const getLoyaltyLionIntegration = {
  name: "getLoyaltyLionIntegration" as const,
  input: z.null(),
  output: z.object({ exists: z.boolean() }),
};
